
import { ProfessionData } from '../types/professionTypes';

export const chauffagiste: ProfessionData = {
  title: "Chauffagiste",
  slug: "chauffagiste",
  description: "Solutions de recyclage pour les équipements thermiques",
  icon: "Flame",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Chaudières et équipements",
      description: "Matériel de chauffage en fin de vie nécessitant un démantèlement spécifique.",
      solutions: ["Collecte des équipements", "Démantèlement valorisant"],
      environmentalBenefit: "Récupération métaux et composants électroniques"
    },
    {
      type: "Fluides caloporteurs",
      description: "Liquides antigel, glycol et autres fluides de circuits thermiques.",
      solutions: ["Pompage et contenants adaptés", "Régénération"],
      environmentalBenefit: "Évite pollution sols et réutilisation possible"
    },
    {
      type: "Gaz frigorigènes",
      description: "Fluides des pompes à chaleur et climatisations soumis à réglementation stricte.",
      solutions: ["Récupération par technicien certifié", "Traitement en filière spécialisée"],
      environmentalBenefit: "Protection couche d'ozone et réduction effet de serre"
    }
  ],
  relatedProfessions: ["plombier", "electricien", "frigoriste"]
};
